import { api } from '@/api/client';
export async function previewPromotion(body) {
    const { data } = await api.post('/v1/promotions/preview', body);
    return data;
}
